import BaseTableNew from 'components/atoms/base-table/new';
import BasePagination from 'components/atoms/base-pagination';
import {
  ADMIN_PANEL_DOCTORS_PER_PAGE,
  useGetAdminPanelDoctors,
} from 'infrastructure/hooks/doctor/use-admin-panel-doctors';
import ResetPasswordModal from 'components/molecules/reset-password-modal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import SearchIcon from 'components/atoms/icons/search.svg?react';
import { scrollToTop } from 'infrastructure/functions';

import { adminPanelUsersColumns } from './columns';
import s from './styles.module.scss';
import { useClinicUsersFilter } from '../users-filter/use-users-filter';

const AdminUsersTable = () => {
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState('');
  const { filter, updateFilter, count } = useClinicUsersFilter();
  const { status, page, clinicGuid, guid, role } = filter;
  const { doctors, isFetching } = useGetAdminPanelDoctors({
    page,
    status,
    role,
    clinicGuid,
    guid,
  });
  const { t } = useTranslation();

  const toggleOpen = () => setOpenModal((prev) => !prev);

  const onClickResetPass = (userEmail: string) => {
    toggleOpen();
    setEmail(userEmail);
  };

  const emptyTableLabel =
    count === 0
      ? t('labels.noUsersFound')
      : t('labels.noUsersFoundByFiltering');

  return (
    <>
      <div className={s.wrapper}>
        <div className={s.header}>
          <p className={s.users}>
            {t('labels.clinicUsers')}: <span>{doctors?.count ?? ''}</span>
          </p>
          <BasePagination
            page={filter?.page}
            total={doctors?.count}
            align="end"
            onChange={async (newPage) => {
              updateFilter({ page: newPage });
            }}
            pageSize={ADMIN_PANEL_DOCTORS_PER_PAGE}
            pageSizeOptions={[]}
            hide={false}
            showSizeChanger={false}
          />
        </div>
        <div className={s.divider} />
        <BaseTableNew
          columns={adminPanelUsersColumns({
            onClickResetPass,
            disabledReset: openModal,
          })}
          bordered
          loading={isFetching}
          items={doctors?.items ?? []}
          pagination={{
            current: page,
            pageSize: ADMIN_PANEL_DOCTORS_PER_PAGE,
            total: doctors?.count ?? 0,
            position: ['bottomCenter'],
          }}
          className={s.table}
          onChangePage={(newPage) => {
            scrollToTop();
            updateFilter({ page: newPage });
          }}
          emptyText={
            <EmptyTablePlaceholder
              text={emptyTableLabel}
              icon={<SearchIcon width={100} height={100} />}
              column
              textColor="purple"
            />
          }
        />
      </div>
      <ResetPasswordModal
        open={openModal}
        toggleOpen={toggleOpen}
        email={email}
        to={t('labels.clinicUser')}
      />
    </>
  );
};
export default AdminUsersTable;
